// Inline hint with a small popover: opens on hover for mouse users and on
// tap/click for everyone else. The popover may hold a link, so it stays open
// while the pointer moves onto it, and a click after a hover pins it open.
if (!customElements.get('info-popover')) {
  customElements.define(
    'info-popover',
    class InfoPopover extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.info-popover__toggle');
        this.panel = this.querySelector('.info-popover__panel');
        if (!this.toggle || !this.panel) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        // Touch input fires pointerenter as well; only a real mouse opens on hover.
        this.addEventListener(
          'pointerenter',
          (event) => event.pointerType === 'mouse' && this.open({ byHover: true }),
          { signal }
        );
        this.addEventListener(
          'pointerleave',
          (event) => event.pointerType === 'mouse' && this.openedByHover && this.close(),
          { signal }
        );
        this.toggle.addEventListener('click', () => this.onToggleClick(), { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.addEventListener('focusout', (event) => !this.contains(event.relatedTarget) && this.close(), { signal });
        document.addEventListener('click', (event) => !this.contains(event.target) && this.close(), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      onToggleClick() {
        if (this.isOpen && this.openedByHover) {
          this.openedByHover = false;
          return;
        }
        this.isOpen ? this.close() : this.open();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.isOpen) return;
        this.close();
        this.toggle.focus();
      }

      open({ byHover = false } = {}) {
        if (this.isOpen) return;
        this.openedByHover = byHover;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        this.setAttribute('open', '');
      }

      close() {
        if (!this.isOpen) return;
        this.openedByHover = false;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
        this.removeAttribute('open');
      }
    }
  );
}
